export const getPointGeomCoordinatesFromLatLng = (latLng: {
    lat: number,
    lng: number
}): {
    type: 'Point',
    coordinates: [lng: number, lat: number]
} => {
    if (!latLng?.lng || !latLng?.lat) {
        return {
            type: 'Point',
            coordinates: [0, 0]
        }
    }
    return {
        type: 'Point',
        coordinates: [latLng.lng, latLng.lat]
    }
}
